import {JRpcSuccResponse} from './jRpcSuccResponse';
import {JRpcErrResponse} from './jRpcErrResponse';

export type JRpcResponse<S> = JRpcSuccResponse<S> | JRpcErrResponse;

export class JsonRpcResponseFactory<S> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getJsonRpcResponseFromObject(object: { [key: string]: any }): JRpcResponse<S> {
        if (
            typeof object.jsonrpc === 'undefined' ||
            (
                typeof object.result === 'undefined' &&
                typeof object.error === 'undefined'
            )
        ) {
            throw new Error(`Invalid json rpc response, ${JSON.stringify(object)}`);
        }

        if (typeof object.result !== 'undefined') {
            return new JRpcSuccResponse<S>(object.result);
        }

        if (typeof object.error !== 'undefined') {
            return new JRpcErrResponse(object.error);
        }

        throw new Error(`Unhandled case detected, response object ${JSON.stringify(object)}`);
    }
}
